import React, { useState } from 'react'
import { Button } from 'devextreme-react'
import SearchSettingsDialog from '../Modals/SettingsModal/SettingsModal'
import './SearchSettings.css'


export const SearchSettings: React.FC = () => {
    const [showDialog, setShowDialog] = useState(false)

    return (
        <>
            {showDialog && <SearchSettingsDialog onClose={()=> setShowDialog(false)} />}
            <div className='search-settings'>
                <Button key={`Setting Button`} onClick={() => setShowDialog(true)} className='button' height={35} stext-align='center'>
                    <span className='glyphicons glyphicons-cogwheels'></span> Settings
                </Button>
            </div>
        </>
    )
}